import { MaintenanceDashboard } from "./MaintenanceDashboard";
export default {
  list: MaintenanceDashboard,
};
